<script>
	const utilities = require('utilities');
	const assignmentService = require('services/assignmentService');

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const { REMOVE_STUDENT_FROM_ASSIGNMENT } = analyticsUtilities.events;

	const { authenticateWithGoogleClassroom, isKnownGoogleClass } = require('utilities/googleClassroomUtilities');

	const { beginAssignmentAction, endAssignmentAction } = require('utilities/assignmentUtilities');

	module.exports = {
		components: {
			modal: require('components/modal.vue').default,
			message: require('components/message.vue').default
		},
		modelData: ['localGCAccessToken', 'gcClassList'],
		data() {
			return {
				suid: null,
				assignment: null,
				roster: null,
				loading: false
			};
		},
		methods: {
			onRemoveStudentClick() {
				this.loading = true;
				let token = this.localGCAccessToken || undefined;
				let assignment = this.assignment;
				let suid = this.suid;
				let aid = assignment ? assignment.assignmentId : null;
				let cc = assignment ? assignment.classCode : null;

				beginAssignmentAction();
				fireEvent(REMOVE_STUDENT_FROM_ASSIGNMENT, {
					suid,
					aid
				});
				return assignmentService
					.removeStudentFromAssignment({
						suid,
						aid,
						cc,
						token
					})
					.then(() => {
						this.closeModals();
					})
					.finally(() => {
						endAssignmentAction();
						this.loading = false;
					});
			},
			closeModals() {
				utilities.closeModals();
			},
			authenticateWithGoogle() {
				authenticateWithGoogleClassroom();
			}
		},
		computed: {
			gcTokenMismatch() {
				const gcid = this.roster && this.roster.gcid;

				return gcid && this.gcClassList && !isKnownGoogleClass(gcid);
			}
		},
		mounted() {
			this.$subscribe('modal-opened', (modalId, opts) => {
				if (modalId !== 'modal-remove-student') {
					return true; // let some other handler take this
				}

				if (opts) {
					this.suid = opts.suid;
					this.assignment = opts.assignment;
					this.roster = opts.roster;
					this.loading = false;
				} else {
					return false;
				}
				return false;
			});

			this.$subscribe('modal-closed', (modalId, opts) => {
				if (modalId !== 'modal-remove-student') {
					return true; // let some other handler take this
				}
				this.suid = null;
				this.assignment = null;
				this.roster = null;
				this.loading = false;
				return false;
			});
		}
	};
</script>
<template>
	<modal
		ref="modal"
		id="modal-remove-student"
		:ok="false"
		:centered="true"
		:loading="loading">
		<template slot="header-container">
			<h2>Remove Student</h2>
		</template>
		<div
			slot="content"
			v-if="assignment"
			class="remove-student-modal-body">
			<p>Are you sure you want to remove this student from the assignment? Any completed work will be deleted and the action cannot be undone.</p>
			<div
				v-if="assignment.gcid && (!localGCAccessToken || gcTokenMismatch)"
				class="margin-top-bottom-medium">
				<message
					v-if="gcTokenMismatch"
					class="margin-top-xs text-left"
					type="error">
					Please authenticate the Google account used to manage this Classroom
				</message>
				<button
					class="button"
					@click="authenticateWithGoogle">
					Authenticate With Google
				</button>
			</div>
			<div class="margin-top-bottom-medium">
				<button
					class="button -outline"
					@click="closeModals">
					Cancel
				</button>
				<template v-if="!assignment.gcid || (assignment.gcid && localGCAccessToken)">
					<button
						class="button -danger"
						@click="onRemoveStudentClick">
						Remove
					</button>
				</template>
				<template v-if="assignment.gcid && !localGCAccessToken">
					<button
						class="button -danger disabled"
						disabled>
						Remove
					</button>
				</template>
			</div>
		</div>
	</modal>
</template>
